export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value))
}

export function roundCents(value: number): number {
  return Math.round(value * 100) / 100
}

export function round(value: number, decimals: number): number {
  const factor = Math.pow(10, decimals)
  return Math.round(value * factor) / factor
}

export function parseNumericInput(input: string | number): number {
  if (typeof input === 'number') return input
  const cleaned = input.replace(/\s+/g, '').replace(/,/g, '')
  const parsed = Number(cleaned)
  return Number.isNaN(parsed) ? NaN : parsed
}
